import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function List4({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <circle className={theme.fill} cx="20" cy="20" r="20" />
      <path
        className={cx(theme.numberFill, theme.secondFill)}
        d="M23.489 22.031h1.487v2.1h-1.487v2.84h-2.606v-2.84h-5.381l-.117-1.64 5.471-8.645h2.633v8.185zm-5.508 0h2.902v-4.633l-.17.297-2.732 4.336z"
      />
    </svg>
  )
}

List4.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
